// @ts-ignore
import { Box } from '@mui/material'
import React, { useEffect, useRef } from 'react'

const Globe: React.FC = () => {
  const globeRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const loadGlobe = async () => {
      const { default: Globe } = await import('globe.gl') // Dynamically import globe.gl
      // const { SphereGeometry, Mesh, MeshPhongMaterial, Texture} = await import('three'); // Import three.js

      if (globeRef.current) {
        const world = new Globe(globeRef.current, { animateIn: false })
          .globeImageUrl(
            'https://unpkg.com/three-globe/example/img/earth-blue-marble.jpg'
          )
          .bumpImageUrl(
            'https://unpkg.com/three-globe/example/img/earth-topology.png'
          )
          .backgroundColor('rgba(23,172,40,0)')
          .showAtmosphere(false)
          .width(600)
          .height(600)
        // Enable auto-rotation
        world.controls().autoRotate = true
        world.controls().autoRotateSpeed = 0.35

        // Add cloud overlay
        // const CLOUDS_IMG_URL = 'https://unpkg.com/three-globe/example/img/earth-topology.png'; // Example cloud texture (replace if needed)
        // const CLOUDS_ALT = 0.004; // Altitude of clouds above globe
        // const CLOUDS_ROTATION_SPEED = -0.006; // Rotation speed in deg/frame
        //
        // new TextureLoader().load(CLOUDS_IMG_URL, (cloudsTexture: any) => {
        //     const clouds = new Mesh(
        //         new SphereGeometry(world.getGlobeRadius() * (1 + CLOUDS_ALT), 75, 75),
        //         new MeshPhongMaterial({map: cloudsTexture, transparent: true})
        //     );
        //     world.scene().add(clouds);
        //
        //     // Animate the clouds
        //     const rotateClouds = () => {
        //         clouds.rotation.y += (CLOUDS_ROTATION_SPEED * Math.PI) / 180;
        //         requestAnimationFrame(rotateClouds);
        //     };
        //     rotateClouds();
        // });
      }
    }

    loadGlobe()
  }, [])

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <Box
        ref={globeRef}
        sx={{
          position: 'relative',
          width: '100%',
          top: 0,
          left: 0,
          margin: 'auto',
          overflow: 'hidden',
          marginTop: '0',
          backgroundColor: 'transparent',
          zIndex: 1,
        }}
      ></Box>

      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          top: 0,
          left: 0,
          margin: 0,
          overflow: 'hidden',
          backgroundColor: 'transparent',
          zIndex: 3,
          //height: '37rem',
          height: 600,
          marginTop: '0',
        }}
      ></Box>
    </Box>
  )
}

export default Globe
